module.exports = __webpack_public_path__ + "static/media/star_fill.df43e87d.svg";